import getApiClient from '@/plugins/api-client'
import { parseFilters } from '@/util/helpers'

export default {
  loadReport () {
    const api = getApiClient(this.$store)

    const params = parseFilters({
        ...this.filters,
      },
    )
    api.get('subscription_reports', { params })
      .then(result => {
        const data = result.data['hydra:member']
        this.reports = data
        const dates = data.map(item => {
          return item.date
        })

        const values = data.map(item => {
          return item.totalSubscriptions
        })

        this.chart.options = {
          ...this.chart.options,
          ...{
            xaxis: {
              categories: dates,
            },
          },
        }

        this.chart.series[0].data = values
      })
      .catch(error => {
        this.error = error.response
      })
  },
  clearFilters () {
    const planId = this.$route.params.id

    this.filters = {
      plan: `/plans/${planId}`,
    }
    this.loadReport()
  },

  exportReport: function () {
    const api = getApiClient(this.$store)

    const params = parseFilters({
        ...this.filters,
      },
    )

    api.get('subscription_reports/export', { params }, { responseType: 'blob' })
      .then(result => {
        const url = window.URL.createObjectURL(new Blob([result.data]))
        const link = document.createElement('a')

        link.href = url
        link.setAttribute('download', 'export.csv')
        document.body.appendChild(link)
        link.click()
      })
      .catch(error => {
        console.log(error)
      })
  },
}
